import recentlyTrackedController from './recently-tracked.controller';
import recentlyTrackedView from './recently-tracked.view.html';
import './recently-tracked.scss';

const recentlyTrackedComponent = {
  template: recentlyTrackedView,
  controller: recentlyTrackedController,
  controllerAs: 'vm'
};

export default recentlyTrackedComponent;


// WEBPACK FOOTER //
// ./src/components/recentlytracked/recently-tracked.component.js